import CompanyApi from '@/api/company-api';

export async function fetchAllCompanies() {
    try {
        const response = await CompanyApi.getAllCompanies();
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error('Failed to fetch all companies');
    }
}
